import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const socials = [
  {
    label: 'GitHub',
    href: 'https://github.com/sharmachaitanya945',
    path: 'M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/sharmachaitanya945/',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
  {
    label: 'X / Twitter',
    href: 'https://twitter.com/Chaitanyatweetx',
    path: 'M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@sharmachaitanya945',
    path: 'M23.498 6.186a2.993 2.993 0 00-2.107-2.117C19.24 3.5 12 3.5 12 3.5s-7.24 0-9.391.569A2.993 2.993 0 00.502 6.186C0 8.338 0 12 0 12s0 3.662.502 5.814a2.993 2.993 0 002.107 2.117C4.76 20.5 12 20.5 12 20.5s7.24 0 9.391-.569a2.993 2.993 0 002.107-2.117C24 15.662 24 12 24 12s0-3.662-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
];

// Static, crawlable landing pages generated by scripts/seo/build-pages.mjs.
const directory = [
  {
    heading: 'Hire',
    links: [
      { label: 'Hire an AI developer', href: '/hire-ai-developer/' },
      { label: 'Rates from $20/hour', href: '/ai-developer-hourly-rate/' },
      { label: 'Client ratings & reviews', href: '/top-rated-ai-freelancer/' },
      { label: 'Hire from India', href: '/hire-ai-developer-india/' },
      { label: 'Hire a full-stack developer', href: '/hire-full-stack-developer/' },
    ],
  },
  {
    heading: 'AI & automation',
    links: [
      { label: 'AI agent development', href: '/services/ai-agent-development/' },
      { label: 'Claude API developer', href: '/services/claude-api-developer/' },
      { label: 'AI chatbots & RAG', href: '/services/ai-chatbot-development/' },
      { label: 'Voice AI agents', href: '/services/voice-ai-agents/' },
      { label: 'n8n automation', href: '/services/n8n-automation/' },
      { label: 'GoHighLevel expert', href: '/services/gohighlevel-expert/' },
    ],
  },
  {
    heading: 'Engineering',
    links: [
      { label: 'SaaS development', href: '/services/saas-development/' },
      { label: 'FastAPI & Python', href: '/services/python-fastapi-development/' },
      { label: 'React development', href: '/services/react-frontend-development/' },
      { label: 'API integration', href: '/services/api-integration/' },
      { label: 'Internal tools', href: '/services/internal-tools-development/' },
      { label: 'All services', href: '/services/' },
    ],
  },
  {
    heading: 'Industries & proof',
    links: [
      { label: 'Real estate', href: '/industries/real-estate/' },
      { label: 'Home services', href: '/industries/home-services/' },
      { label: 'Solar', href: '/industries/solar/' },
      { label: 'Case studies', href: '/case-studies/' },
      { label: 'Certifications', href: '/certifications/' },
      { label: 'Blog', href: '/blog/' },
    ],
  },
];

const Footer: React.FC = () => {
  const { themeConfig } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative mt-16 border-t border-canvas-border/60 bg-canvas-base/70 py-10">
      <div className={`${themeConfig.layout?.containerStyle}`}>
        <div className="flex flex-col items-center justify-between gap-8 md:flex-row md:items-start">
          <div className="text-center md:text-left">
            <div className="mb-2 flex items-center justify-center gap-2 md:justify-start">
              <span className="live-dot" />
              <span className="font-mono text-xs uppercase tracking-widest text-neon-green">
                open to new builds
              </span>
            </div>
            <p className="font-display text-lg font-semibold text-ink-main">
              Chaitanya Sharma
            </p>
            <p className="text-sm text-ink-soft">
              AI &amp; Full-Stack Developer · SaaS · AI Agents · n8n &amp; GoHighLevel
            </p>
            <a
              href="https://charyxlabs.tech"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 transition-colors"
              style={{ borderColor: '#d9642c59', background: '#d9642c12' }}
            >
              <img
                src="/assets/logos/charyxlabs.svg"
                alt=""
                aria-hidden="true"
                width={18}
                height={18}
                className="rounded"
                style={{ width: 18, height: 18 }}
              />
              <span className="font-mono text-xs" style={{ color: '#d9642c' }}>
                studio: charyxlabs.tech ↗
              </span>
            </a>
            <div className="mt-4 flex flex-wrap justify-center gap-4 text-sm md:justify-start">
              <Link to="/terms" className="text-ink-muted transition-colors hover:text-neon-cyan">
                Terms
              </Link>
              <Link to="/privacy" className="text-ink-muted transition-colors hover:text-neon-cyan">
                Privacy
              </Link>
              <Link to="/freelance" className="text-ink-muted transition-colors hover:text-neon-cyan">
                Freelance
              </Link>
            </div>
          </div>

          <div className="flex gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                className="grid h-10 w-10 place-items-center rounded-lg border border-canvas-border bg-canvas-node text-ink-soft transition-all hover:border-neon-cyan/60 hover:text-neon-cyan hover:shadow-neon-cyan"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d={s.path} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        <nav
          aria-label="Site directory"
          className="mt-10 grid grid-cols-2 gap-8 border-t border-canvas-border/40 pt-8 md:grid-cols-4"
        >
          {directory.map((col) => (
            <div key={col.heading}>
              <p className="mb-3 font-mono text-[11px] uppercase tracking-widest text-neon-cyan">
                {col.heading}
              </p>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-sm text-ink-soft transition-colors hover:text-neon-cyan">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

        <div className="mt-8 border-t border-canvas-border/40 pt-6 text-center text-xs text-ink-muted">
          © {currentYear} Chaitanya Sharma · Built &amp; deployed like a workflow — triggered, automated, shipped.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
